module.exports = __webpack_public_path__ + "img/Memberkit-2-es.c36b7d82.png";